const config = {
  apiBaseUrl: "https://backend.hindustanwardrobe.in",
  // apiBaseUrl: 'http://localhost:4000',
  googleClientId:
    "787536694909-9mtt2mepbl0s6up56qnp31voehft2fh1.apps.googleusercontent.com",
  webHomeCollections: "user/webHomeAPI",
  exploreAll:"user/explore",
  allProducts: "user/getAllProducts",
  subCategory: "user/subcatProduct",
  deleteUserAccount: "user/userDeletionRequest",
  userSignIn: "user/signIn",
  getMainCategories: "user/getMainCat",
  getCategoryAndSubCategory: "user/getCategoryAndSubCategory",
  ownerProfile: "user/ownerProfile",
  popularProducts: "user/popularProducts",
  getProductDetail: "user/getProductById",
  addToWishlist: "user/addtoWishlist",
  booNow: "user/bookNow",
  tryOnTime: "user/getTryOnTime",
  getReview: "user/getReviews",
  bookingDetails: "user/getBookingRequestById",
  bookingRequest: "user/getBookingRequest",
  getWellet: "user/getWallet",
  transactionHistory: "user/getTransactionHistory",
  getOrders: "user/getOrders",
  getOrderDetails: "user/getOderById",
  userProfile: "user/getUser",
  updateUserProfile: "user/updateUser",
  getUserWishlist: "user/getWishList",
  removeFromWishlist: "user/removeWishlist",
  relatedProducts: "user/subcatProduct",
  googleSignIn: "user/googleSignIn",
  marketingAttribution: "market/attribution",
  marketiigAttributionUser: "market/attribution/user",
};

export default config;
